import appSettings from 'config/application/app-settings';
import getGACookie from 'utils/getGACookie';
import getQueryVariable from 'utils/getQueryVariable';

export const createLead = ({ phoneNumber, token }) => {
  const response = token ? `response=${token}` : '';
  return {
    url: `/oapi/landing?${response}`,
    baseURL: appSettings.SME_SERVICE_BASE_URL,
    method: 'POST',
    accept: 'application/json',
    data: {
      authenticationType: 'SMS_AUTHENTICATION',
      companyName: 'company name new auth',
      googleId: getGACookie() || null,
      phoneNumber: `8${phoneNumber}`,
      utmCampaign: getQueryVariable('utm_campaign') || null,
      utmMedium: getQueryVariable('utm_medium') || null,
      utmSource: getQueryVariable('utm_source') || null,
      utmTerm: getQueryVariable('utm_term') || null,
      channel: 'CONTEXTUAL_ADVERTISING',
      segment: appSettings.SEGMENT
    }
  };
};

export const requestCode = ({ phoneNumber, token }) => {
  const response = token ? `recaptcha=${token}` : '';
  return {
    url: `/oapi/authenticate?${response}`,
    baseURL: appSettings.AUTH_SERVICE_BASE_URL,
    method: 'POST',
    accept: 'application/json',
    data: {
      phoneNumber
    }
  };
};

export const sendCode = ({ phoneNumber, code, messageId }) => {
  return {
    url: '/oapi/authorize',
    baseURL: appSettings.AUTH_SERVICE_BASE_URL,
    method: 'POST',
    accept: 'application/json',
    data: {
      messageId,
      phoneNumber,
      code,
      redirectUri: appSettings.REDIRECT_URI
    }
  };
};
